import { render, staticRenderFns } from "./Knee.vue?vue&type=template&id=17ad08b6&"
import script from "./Knee.vue?vue&type=script&lang=js&"
export * from "./Knee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports